// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-policy-wrapper {
	display: inline-block;
	vertical-align: top; /* Aligns vertically if needed */
}
.data-policy-button {
	border-top-color: #d0d0d0 !important;
	border-left-color: #c3c3c3 !important;
	border-right-color: #c3c3c3 !important;
	border-bottom-color: #b8b9ba !important;
	border: 1px solid #d2d3d3 !important;
	border-radius: 3px;
	box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
	display: inline-flex;
	justify-content: space-around;
	align-items: center;
	height: 21.75px;
	vertical-align: middle;
	padding-bottom: 2px;
}
.data-policy-white {
	/* padding: 3px 8px; */
	cursor: pointer;
	align-items: center;
	justify-content: space-around;
	/* height: 2.2rem;  */
}
.data-policy-button svg {
	height: 21px;
	width: 21px;
	vertical-align: middle;
}

.data-policy-button svg path {
	translate: -2px 0px;
	scale: 1.12 1.1;
}

.data-policy-button .data-policy-white.data-policy-embed {
	/* display: inline; */
	text-decoration: none;
	color: #000000a6 !important;
	font-weight: bold;
	line-height: 2rem;
	/* text-align: unset; */
	/* padding-left: 10px; */
	margin-right: 1rem;
	font-size: 11px;
	font-family: "Helvetica Neue", Helvetica, Arial, FreeSans, sans-serif;
	text-align: center;
	margin-top: 2px;
	transform: translateX(-3px);
}
`, "",{"version":3,"sources":["webpack://./src/components/cookieConsent/DataPolicy/dataPolicy.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB,mBAAmB,EAAE,gCAAgC;AACtD;AACA;CACC,oCAAoC;CACpC,qCAAqC;CACrC,sCAAsC;CACtC,uCAAuC;CACvC,oCAAoC;CACpC,kBAAkB;CAClB,uCAAuC;CACvC,oBAAoB;CACpB,6BAA6B;CAC7B,mBAAmB;CACnB,eAAe;CACf,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,eAAe;CACf,mBAAmB;CACnB,6BAA6B;CAC7B,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,2BAA2B;CAC3B,iBAAiB;CACjB,iBAAiB;CACjB,uBAAuB;CACvB,wBAAwB;CACxB,kBAAkB;CAClB,eAAe;CACf,qEAAqE;CACrE,kBAAkB;CAClB,eAAe;CACf,2BAA2B;AAC5B","sourcesContent":[".data-policy-wrapper {\n\tdisplay: inline-block;\n\tvertical-align: top; /* Aligns vertically if needed */\n}\n.data-policy-button {\n\tborder-top-color: #d0d0d0 !important;\n\tborder-left-color: #c3c3c3 !important;\n\tborder-right-color: #c3c3c3 !important;\n\tborder-bottom-color: #b8b9ba !important;\n\tborder: 1px solid #d2d3d3 !important;\n\tborder-radius: 3px;\n\tbox-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);\n\tdisplay: inline-flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\theight: 21.75px;\n\tvertical-align: middle;\n\tpadding-bottom: 2px;\n}\n.data-policy-white {\n\t/* padding: 3px 8px; */\n\tcursor: pointer;\n\talign-items: center;\n\tjustify-content: space-around;\n\t/* height: 2.2rem;  */\n}\n.data-policy-button svg {\n\theight: 21px;\n\twidth: 21px;\n\tvertical-align: middle;\n}\n\n.data-policy-button svg path {\n\ttranslate: -2px 0px;\n\tscale: 1.12 1.1;\n}\n\n.data-policy-button .data-policy-white.data-policy-embed {\n\t/* display: inline; */\n\ttext-decoration: none;\n\tcolor: #000000a6 !important;\n\tfont-weight: bold;\n\tline-height: 2rem;\n\t/* text-align: unset; */\n\t/* padding-left: 10px; */\n\tmargin-right: 1rem;\n\tfont-size: 11px;\n\tfont-family: \"Helvetica Neue\", Helvetica, Arial, FreeSans, sans-serif;\n\ttext-align: center;\n\tmargin-top: 2px;\n\ttransform: translateX(-3px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
